import { of } from 'rxjs';
import { Component, ViewChild, EventEmitter } from '@angular/core';
import { AgGridNg2 } from 'ag-grid-angular';
import { SelectItem, MenuItem, MessageService } from 'primeng/api';
import {
  ConfirmationService
} from 'primeng/api';
import * as XLSX from 'xlsx';
import { BillingService } from '../service/billing/billing.service';
import { IMyDrpOptions, IMyOptions } from 'mydaterangepicker';
import { RowType, LargeTextCellEditor } from 'ag-grid-community';
import { CustomNoRowsOverlay } from './no-rows-overlay/custom-no-rows-overlay.component';
declare var jsPDF: any;
const CONFIRM_MESSAGE = 'Certaines données sont sélectionnées. Voulez-vous exporter uniquement les données sélectionnées?';
const CONFIRM_HEADER = 'Exporter les données sélectionnées';
const DEFAULT_PAGINATION_NUMBER = 20;
const FILENAME = 'Facturation';
@Component({
  selector: 'app-extraction',
  templateUrl: './extraction.component.html',
  styleUrls: ['./extraction.component.scss'],
  providers: [ConfirmationService]
})
export class ExtractionComponent {
  defaultColDef: any;
  billingRowData: any;
  rowSelection: any;
  billingColumnDefs: any;
  billingGrid: any;
  pageLimit: SelectItem[];
  selectedpageLimit: any;
  gridColumnApi: any;
  @ViewChild('gridRef',{  static: false}) gridRef: AgGridNg2;
  rowData: any;
  items: MenuItem[];
  globalFilter: string;
  dateSelected: boolean;
  noResults: boolean;
  rowDeselection: boolean = true;
   frameworkComponents;
   noRowsOverlayComponent;
  placeholderTxt = 'Sélectionnez une plage de dates...'
  myDateRangePickerOptions: IMyDrpOptions = {
    dateFormat: 'yyyy-mm-dd',
    editableDateRangeField: false,
    openSelectorOnInputClick: true
  };
  isIEOrEdge;

  public model: any = {};

  constructor(
    private billingService: BillingService,
    private confirmService: ConfirmationService
  ) {
    this.selectedpageLimit = DEFAULT_PAGINATION_NUMBER;
    this.rowSelection = "multiple";

    this.items = [
      {
        label: 'Export CSV', icon: 'pi pi-file', command: () => {
          this.exportCSV();
        }
      },
      {
        label: 'Export Excel', icon: 'pi pi-file', command: () => {
          this.exportXlSX();
        }
      },
      {
        label: 'Export PDF', icon: 'pi pi-file', command: () => {
          this.exportPDF();
        }
      },
    ];

    this.isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);


    this.pageLimit = [
      { label: '5', value: 5 },
      { label: '10', value: 10 },
      { label: '15', value: 15 },
      { label: '20', value: 20 }
    ];


    this.billingColumnDefs = [
      {
        headerName: 'Collection de données',
        field: 'dataCollection',
        unSortIcon: true
      },
      {
        headerName: 'Date',
        field: 'creationDate',
        unSortIcon: true
      },
      {
        headerName: 'User id POI',
        field: 'user',
        unSortIcon: true
      },
      {
        headerName: 'VIN',
        field: 'vin',
        unSortIcon: true
      }


    ];

    this.frameworkComponents = {
      customNoRowsOverlay: CustomNoRowsOverlay
    };
    this.noRowsOverlayComponent = "customNoRowsOverlay";

    this.defaultColDef = { resizable: true };
  }



  onPageSizeChanged() {
    let selectedSize = this.selectedpageLimit > 0 ? this.selectedpageLimit : DEFAULT_PAGINATION_NUMBER;
    this.billingGrid.paginationSetPageSize(Number(selectedSize));
    this.billingGrid.sizeColumnsToFit();
  }

  onGridReady(params) {
    this.billingGrid = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
   
  }

  exportCSV() {

    var params = {};
    let selectedNodes: any;
    selectedNodes = this.billingGrid.getSelectedRows();
    this.gridRef.api.setSortModel(null);

    if (selectedNodes.length > 0) {
      this.confirmService.confirm({
        message: CONFIRM_MESSAGE,
        header: CONFIRM_HEADER,
        icon: 'pi pi-info-circle',
        accept: () => {
          params = {
            fileName: FILENAME,
            onlySelected: true
          };
          this.billingGrid.exportDataAsCsv(params);
          this.deselectRows();
        },
        reject: () => {
          params = {
            fileName: FILENAME
          };
          this.billingGrid.exportDataAsCsv(params);
          this.deselectRows();
        }
      });
    } else {
      params = {
        fileName: FILENAME
      };
      this.billingGrid.exportDataAsCsv(params);
      this.deselectRows();
    }


  }

  exportXlSX() {
    let headers = [];

    this.gridRef.columnApi.getAllGridColumns().forEach(element => {
      headers.push(element.getColDef().headerName)
    })

    this.getDataForFileGeneration(false, headers).then(data => {
      /* generate worksheet */

      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      XLSX.writeFile(wb, 'Facturation.xlsx');
    });

  }

  exportPDF() {
    // jsPDF 1.4.1 and jspdf-autotable 2.3.5 are loaded as global <script> bundles
    // (see the "scripts" array in angular.json), which is how the autoTable plugin
    // patches jsPDF.API.autoTable on the *global* jsPDF constructor. Calling
    // require('jspdf') here instead creates a second, separately bundled jsPDF
    // constructor that the plugin never patches, so doc.autoTable is undefined.
    // Always construct documents from the global jsPDF so the patched API is used.
    let doc = new jsPDF();
    let headers = [];

    this.gridRef.columnApi.getAllGridColumns().forEach(element => {
      headers.push(element.getColDef().headerName)
    })

    this.getDataForFileGeneration(true, headers).then(data => {
      // jspdf-autotable 2.3.5 only supports the classic positional API
      // (headers, data, options) — it does NOT support the newer single
      // config-object API (doc.autoTable({ head, body })). Passing a config
      // object as the first argument makes the plugin's internal
      // inputHeaders.forEach(...) throw, since inputHeaders is then an
      // object instead of the expected array of header strings.
      doc.autoTable(headers, data);
      doc.save('Facturation.pdf');
    });



  }


  getDataForFileGeneration(returnArrayOfAray?: boolean, headers?: any) {
    let data: any[] = [];
    let selectedNodes: any;
    selectedNodes = this.billingGrid.getSelectedRows();

    var promise = new Promise<any[]>((resolve, reject) => {
      if (selectedNodes.length > 0) {

        this.confirmService.confirm({
          message: CONFIRM_MESSAGE,
          header: CONFIRM_HEADER,
          icon: 'pi pi-info-circle',
          accept: () => {

            if (returnArrayOfAray) {
              this.getArrayOfArray(headers, data, selectedNodes)

            } else {
              this.getArrayOfObjects(headers, data, selectedNodes)

            }
            this.deselectRows();
            resolve(data);

          },
          reject: () => {

            if (returnArrayOfAray) {

              this.getArrayOfArray(headers, data, this.rowData)


            } else {
              this.getArrayOfObjects(headers, data, this.rowData)

            }
            this.deselectRows();
            resolve(data);

          }
        });


      } else {
        if (returnArrayOfAray) {

          this.getArrayOfArray(headers, data, this.rowData)

        } else {
          this.getArrayOfObjects(headers, data, this.rowData)
        }
        this.deselectRows();
        resolve(data);

      }


    });
    return promise;
  }

  extractBillingdata() {

    this.resetAllData();

    let fromDate = `${this.model.beginDate.year}-${this.model.beginDate.month}-${this.model.beginDate.day}`;
    let toDate = `${this.model.endDate.year}-${this.model.endDate.month}-${this.model.endDate.day}`

    this.billingService.extractBillingData(fromDate, toDate).subscribe(data => {
      this.noResults = false;
      this.rowData = data;
      if (this.billingGrid)
        this.billingGrid.sizeColumnsToFit();
    },
      error => {
        this.rowData = null;
        this.noResults = true;
      }
    );

  }

  onDateRangeChanged(event) {

    event.beginJsDate == null ? this.dateSelected = false : this.dateSelected = true;

  }

  onModelUpdated(){
    if(this.billingGrid && this.billingGrid.rowModel.rowsToDisplay.length == 0) {
      this.billingGrid.showNoRowsOverlay();
    }
    if(this.billingGrid && this.billingGrid.rowModel.rowsToDisplay.length > 0) {
      this.billingGrid.hideOverlay();
    }
  }

  filterBillingData() {
  
    this.gridRef.api.setQuickFilter(this.globalFilter);
    this.gridRef.api.sizeColumnsToFit();
    this.onModelUpdated();
  
  }

  deselectRows() {
    if (this.gridRef) {
      this.gridRef.api.deselectAll();
    }
  }

  getArrayOfArray(headers: any[], data: any[], Iterable: any) {

    let col1 = headers[0];
    let col2 = headers[1];
    let col3 = headers[2];
    let col4 = headers[3];

    let objectKeys = [];
    objectKeys.push(col1);
    objectKeys.push(col2);
    objectKeys.push(col3);
    objectKeys.push(col4);

    let keys = [];


    objectKeys.forEach(data => {
      switch (data) {
        case 'Collection de données':
          keys.push('dataCollection');
          break;

        case 'VIN':
          keys.push('vin');
          break;

        case 'Date':
          keys.push('creationDate');
          break;

        case 'User id POI':
          keys.push('user');
          break;

      }
    });


    Iterable.forEach(element => {
      data.push([
        element[keys[0]],
        element[keys[1]],
        element[keys[2]],
        element[keys[3]]
      ])
    });
  }

  getArrayOfObjects(headers: any[], data: any[], Iterable: any) {

    let col1 = headers[0];
    let col2 = headers[1];
    let col3 = headers[2];
    let col4 = headers[3];

    let objectKeys = [];
    objectKeys.push(col1);
    objectKeys.push(col2);
    objectKeys.push(col3);
    objectKeys.push(col4);

    let keys = [];


    objectKeys.forEach(data => {
      switch (data) {
        case 'Collection de données':
          keys.push('dataCollection');
          break;

        case 'VIN':
          keys.push('vin');
          break;

        case 'Date':
          keys.push('creationDate');
          break;

        case 'User id POI':
          keys.push('user');
          break;

      }
    });

    Iterable.forEach(element => {

      data.push(
        {
          [col1]: element[keys[0]],
          [col2]: element[keys[1]],
          [col3]: element[keys[2]],
          [col4]: element[keys[3]]
        }
      )
    });
  }

  resetAllData() {
    if (this.gridRef) {
      this.gridRef.api.clearFocusedCell();
      this.gridRef.gridOptions.api.setFilterModel(null);
      this.gridRef.gridOptions.api.deselectAll();
      this.gridRef.api.setQuickFilter(null);
      this.gridRef.api.setSortModel(null);
      this.globalFilter = '';
    }

  }


}

